import { useEffect, useRef, useState } from 'react';

import { OverlayEventDetail } from '@ionic/core/components';
import { useIonModal } from '@ionic/react';

import { IModalHook, IParams, IPresentOptions } from './interfaces';

export const useModal = (
  Modal: any,
  hookOptions = {},
  presentOptions: IPresentOptions = {}
): IModalHook => {
  const [_params, _setParams] = useState<IParams>({});
  const _presentNow = useRef<boolean>(false);
  const _promiseControls = useRef<Array<(value: unknown) => void>>([]);

  const { onSubmit, onClose, onExited, ...componentParams } = _params;
  const [present, dismiss] = useIonModal(Modal, {
    ...componentParams,
    ...hookOptions,
    onSubmit: (data: any) => dismiss(data, 'submit'),
    onClose: (data: any) => dismiss(data, 'close'),
  });

  useEffect(() => {
    if (_presentNow.current) {
      _presentNow.current = false;
      const [resolve, reject] = _promiseControls.current;
      present({
        ...presentOptions,
        onWillDismiss: (ev: CustomEvent<OverlayEventDetail>) => {
          if (ev.detail.role === 'submit') {
            onSubmit && onSubmit(ev.detail.data);
          } else if (ev.detail.role === 'close') {
            onClose && onClose(ev.detail.data);
          }
        },
        onDidDismiss: (ev: CustomEvent<OverlayEventDetail>) => {
          onExited && onExited(ev.detail.data);
          if (ev.detail.role === 'submit') {
            resolve(ev.detail.data);
          } else if (ev.detail.role === 'close') {
            reject(ev.detail.data);
          }
        },
      });
    }
  }, [onSubmit, onClose, onExited, present, presentOptions, _params]);

  const handleOpen = (params: IParams = {}) => {
    _setParams(params);
    _presentNow.current = true;
    return new Promise((resolve, reject) => {
      _promiseControls.current = [resolve, reject];
    });
  };

  const handleClose = (data?: any) => {
    dismiss(data, 'close');
    _setParams({});
    _presentNow.current = false;
    _promiseControls.current = [];
  };

  return [handleOpen, handleClose];
};
